import React from "react";
import { Row, Col } from "react-flexbox-grid";
import { TextField } from "react-md";
import moment from "moment";
import { CART_STATUS_DRAFT } from "../../constants/cart-constants";

const formatDateTime = (value) => {
  if (!value) return "-";
  const m = moment(value);
  return m.isValid() ? m.format("DD MMM YYYY hh:mm A") : "-";
};

const hasValidDateTime = (value) => {
  if (!value) return false;
  const m = moment(value);
  return m.isValid() && m.year() > 1;
};

const CartIdDetailsSection = ({ cart }) => {
  if (!cart) return null;
  // A draft is the patient's in-progress basket, so its id and timestamps are not
  // meaningful to show yet.
  if (cart.status === CART_STATUS_DRAFT) return null;

  const showPendingVerificationAt = hasValidDateTime(cart.pendingVerificationAt);

  return (
    <div>
      <h3>{`Cart details`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="cart-module-create-service-field-container">
            <div className="cart-module-label">Cart ID</div>
            <div>
              <TextField
                value={cart.id != null ? String(cart.id) : "-"}
                lineDirection="left"
                disabled
              />
            </div>
          </div>
        </Col>
        {showPendingVerificationAt && (
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
        )}
        {showPendingVerificationAt && (
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="cart-module-create-service-field-container">
              <div className="cart-module-label">Creation date and time</div>
              <div>
                <TextField
                  value={formatDateTime(cart.pendingVerificationAt)}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default CartIdDetailsSection;
